<form #addressForm="ngForm">
  <div>
    <wz-geo-autocomplete
      [disabled]="disabled"
      matInput
      (valueChange)="onAddressValueChange($event)"
    >
    </wz-geo-autocomplete>
  </div>
  <div class="full-address" [wzShowTransition]="isFullAddressVisible">
    <div class="border-left">
      <div class="row">
        <div class="col-sm-2">
          <mat-form-field>
            <wz-text-input
              [disabled]="disabled"
              #streetNumberControl="ngModel"
              type="number"
              [(ngModel)]="addressValue.streetNumber"
              (input)="propagate()"
              placeholder="N°"
              name="roadNumber"
            >
            </wz-text-input>
            <mat-error
              *ngIf="streetNumberControl.hasError('required')"
              wzI18n="FORMS_ADDRESS_STREET_REQUIRED"
            >
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-2 mt-1 mt-sm-0">
          <mat-form-field>
            <wz-text-input
              [disabled]="disabled"
              #repControl="ngModel"
              [(ngModel)]="addressValue.repetition"
              (input)="propagate()"
              placeholder="AUCUN/BIS/TER"
              name="repetition"
            ></wz-text-input>
          </mat-form-field>
        </div>
        <div class="col-sm-3 mt-1 mt-sm-0">
          <mat-form-field>
            <wz-text-input
              [disabled]="disabled"
              #streetTypeControl="ngModel"
              [required]="true"
              stringNotEmptyAndTrimmed
              atLeastOneLetterRequired
              (input)="propagate()"
              [(ngModel)]="addressValue.streetType"
              placeholder="Type de voie"
              name="roadType"
            >
            </wz-text-input>
            <mat-error
              *ngIf="streetTypeControl.hasError('required')"
              wzI18n="FORMS_ADDRESS_STREETTYPE_REQUIRED"
            >
            </mat-error>
            <mat-error
              *ngIf="
                streetTypeControl.hasError('stringNotEmptyAndTrimmed') &&
                !streetTypeControl.hasError('required')
              "
              wzI18n="FORMS_ADDRESS_STREETTYPE_STRING_NOT_EMPTY_AND_TRIMMED"
            >
            </mat-error>

            <mat-error
              *ngIf="
                streetTypeControl.hasError('atLeastOneLetterRequired') &&
                !streetTypeControl.hasError('required')
              "
              wzI18n="FORMS_ADDRESS_STREETTYPE_AT_LEAST_ONE_LETTER_REQUIRED"
            >
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-5 mt-1 mt-sm-0">
          <mat-form-field>
            <wz-text-input
              [disabled]="disabled"
              #streetNameControl="ngModel"
              [required]="true"
              stringNotEmptyAndTrimmed
              atLeastOneLetterRequired
              [(ngModel)]="addressValue.streetName"
              (input)="propagate()"
              placeholder="Nom voie"
              name="roadName"
            >
            </wz-text-input>
            <mat-error
              *ngIf="streetNameControl.hasError('required')"
              wzI18n="FORMS_ADDRESS_STREET_REQUIRED"
            >
            </mat-error>
            <mat-error
              *ngIf="
                streetNameControl.hasError('stringNotEmptyAndTrimmed') &&
                !streetNameControl.hasError('required')
              "
              wzI18n="FORMS_ADDRESS_STREET_STRING_NOT_EMPTY_AND_TRIMMED"
            >
            </mat-error>

            <mat-error
              *ngIf="
                streetNameControl.hasError('atLeastOneLetterRequired') &&
                !streetNameControl.hasError('required')
              "
              wzI18n="FORMS_ADDRESS_STREET_AT_LEAST_ONE_LETTER_REQUIRED"
            >
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field>
            <wz-text-input
              [disabled]="disabled"
              #complementControl="ngModel"
              [(ngModel)]="addressValue.complement"
              (input)="propagate()"
              placeholder="Complément d'adresse"
              name="complement"
            ></wz-text-input>
          </mat-form-field>
        </div>
      </div>
      <div
        class="city-container"
        *ngIf="addressRepository; else wzTmp"
        [formGroup]="formGroup"
      >
        <mat-form-field class="zip">
          <wz-text-input
            placeholder="Code postal"
            formControlName="cityZipCode"
          ></wz-text-input>
        </mat-form-field>
        <mat-form-field class="city">
          <wz-select2
            [items]="cityList"
            [isLoading]="isFetchingCities"
            placeholder="Ville"
            formControlName="codeInsee"
          >
          </wz-select2>
          <mat-hint *ngIf="isFetchingCities"
            >Récupération des villes correspondantes</mat-hint
          >
          <mat-hint
            *ngIf="!isFetchingCities && cityList && cityList.length === 0"
            >Aucune ville ne correspond à ce code postal</mat-hint
          >
        </mat-form-field>
      </div>
      <ng-template #wzTmp>
        <div class="row">
          <div class="col-sm-5">
            <mat-form-field>
              <wz-text-input
                [disabled]="disabled || !!(config && !config.cityZipCode)"
                #zipControl="ngModel"
                [required]="true"
                stringNotEmptyAndTrimmed
                placeholder="Code postal"
                name="postalCode"
                (input)="propagate()"
                [(ngModel)]="addressValue.cityZipCode"
              ></wz-text-input>
              <mat-error
                *ngIf="zipControl.hasError('required')"
                wzI18n="FORMS_ADDRESS_ZIP_REQUIRED"
              >
              </mat-error>
              <mat-error
                *ngIf="
                  zipControl.hasError('stringNotEmptyAndTrimmed') &&
                  !zipControl.hasError('required')
                "
                wzI18n="FORMS_ADDRESS_ZIP_STRING_NOT_EMPTY_AND_TRIMMED"
              >
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-7 mt-1 mt-sm-0">
            <mat-form-field>
              <wz-text-input
                [disabled]="disabled || !!(config && !config.cityName)"
                #cityControl="ngModel"
                [required]="true"
                stringNotEmptyAndTrimmed
                placeholder="Ville"
                name="city"
                [(ngModel)]="addressValue.cityName"
                (input)="propagate()"
              >
              </wz-text-input>
              <mat-error
                *ngIf="cityControl.hasError('required')"
                wzI18n="FORMS_ADDRESS_CITY_REQUIRED"
              >
              </mat-error>
              <mat-error
                *ngIf="
                  cityControl.hasError('stringNotEmptyAndTrimmed') &&
                  !cityControl.hasError('required')
                "
                wzI18n="FORMS_ADDRESS_CITY_STRING_NOT_EMPTY_AND_TRIMMED"
              >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</form>
